import MxFormErrorMessage from "@rf-l2/form/MxFormErrorMessage";
import MxFormFieldController from "@rf-l2/form/MxFormFieldController";
import MxFormSelectAgentsField, {
  MxFormSelectAgentsFieldProp
} from "@rf-l2/form/select/MxFormSelectAgentsField";

export interface MxFormL3SelectAgentsFieldProps extends MxFormSelectAgentsFieldProp {
  name: string;
  withreacthookform?: 1 | 0;
}
const MxFormL3SelectAgentsField = (props: MxFormL3SelectAgentsFieldProps) => {
  return (
    <MxFormFieldController
      name={props.name}
      withreacthookform={props.withreacthookform}
    >
      <MxFormSelectAgentsField {...props} />
      <MxFormErrorMessage />
    </MxFormFieldController>
  );
};

export default MxFormL3SelectAgentsField;
